import { connect } from 'react-redux';
import { signOut } from '../../features/auth/authSlice';
import { getMSISDN } from '../../features/auth/selectors';
import auth from '../../features/auth/utils/mym';
import { RootState, AppDispatch } from '../../app/store';
import Header from './Header';

const mapStateToProps = (state: RootState) => ({
  msisdn: getMSISDN(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onLogoutClick: () => auth.logout(() => dispatch(signOut())),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
